import { render, staticRenderFns } from "./tipoPagamento.vue?vue&type=template&id=5d3bf2ee"
import script from "./tipoPagamento.vue?vue&type=script&lang=js"
export * from "./tipoPagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports